export const ADDRESS_FORM = 'address_form';
export const PICKUP_FORM = 'pickup_form';
export const PRODUCT_FORM = 'product_form';
export const PAGE_LOADER = 'page_loader';
export const INLINE_LOADER = 'inline_loader';
export const ALREADY_SUBMITTED = '08022';
